import { createTheme } from "react-data-table-component";

createTheme(
  "darkTransparent",
  {
    background: {
      default: "transparent"
    },
    text: {
      primary: "#fff"
    },
    divider: {
      default: "#444"
    }
  },
  "dark"
);
